import { infiniteQueryOptions, skipToken } from '@tanstack/react-query';
import { createTRPCOptionsResult, getClientArgs } from './utils.mjs';

function trpcInfiniteQueryOptions(args) {
    const { input, query, path, queryKey, opts } = args;
    const inputIsSkipToken = input === skipToken;
    const queryFn = async (queryFnContext)=>{
        const actualOpts = {
            ...opts,
            trpc: {
                ...opts?.trpc,
                ...opts?.trpc?.abortOnUnmount ? {
                    signal: queryFnContext.signal
                } : {
                    signal: null
                }
            }
        };
        const result = await query(...getClientArgs(queryKey, actualOpts, {
            direction: queryFnContext.direction,
            pageParam: queryFnContext.pageParam
        }));
        return result;
    };
    return Object.assign(infiniteQueryOptions({
        ...opts,
        queryKey,
        queryFn: inputIsSkipToken ? skipToken : queryFn,
        initialPageParam: opts?.initialCursor ?? input?.cursor
    }), {
        trpc: createTRPCOptionsResult({
            path
        })
    });
}

export { trpcInfiniteQueryOptions };
